export enum OrderAccessInviteStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
}

export enum OrderAccessRole {
  VIEWER = 'VIEWER',
  MANAGER = 'MANAGER',
}

export enum OrderAccessStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type OrderAccessOption = {
  value: OrderAccessRole
  description: string
}

export type SuggestedTraveller = {
  name: string
  email: string
}
